import TemplateView from "../../TemplateView"
import $ from 'jquery'

/**
 * @author makovchik.
 * @since 15.10.2018.
 */

export default class TasksNotFoundMessage extends TemplateView {

    constructor() {
        super()

        this.state = {
            showLinkToAllTasks: false,
        }

        this.onStatePropertyChanged('showLinkToAllTasks', (show) => {
            this.$secondSentence.toggle(show)
        })
    }

    templateHtml() {
        return  "  <div class='tasksNotFoundMessage'>" +
                "    <p class='firstSentence'><%-notFoundFirstSentence%></p>" +
                "    <p class='secondSentence'><%-notFoundSecondSentence%> <a class='allTasksLink' href='#'><%-notFoundSecondSentenceAllTasks%></a></p>" +
                "  </div>"
    }

    afterRender() {
        this.find(".allTasksLink").click(() => $(document).trigger("taskManagement_tasksTable_allTasksClick")
        )

        this.$secondSentence = this.find(".secondSentence")
    }

    messageKeys() {
        return {
            notFoundFirstSentence: "task.list.tasks_not_found_first_sentence",
            notFoundSecondSentence: "task.list.tasks_not_found_second_sentence",
            notFoundSecondSentenceAllTasks: "task.list.tasks_not_found_second_sentence_all_tasks",
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/components/TasksNotFoundMessage.js